var map = {
	"./news.de-CH.json": 1417,
	"./news.de-DE.json": 1418,
	"./news.en-CA.json": 1419,
	"./news.en-GB.json": 1420,
	"./news.en-IN.json": 1421,
	"./news.en-ME.json": 1422,
	"./news.en-US.json": 1423,
	"./news.es-EM.json": 1424,
	"./news.es-ES.json": 1425,
	"./news.fr-BE.json": 1426,
	"./news.fr-CA.json": 1427,
	"./news.fr-CH.json": 1428,
	"./news.nl-BE.json": 1429,
	"./news.nl-NL.json": 1430,
	"./news.pl-PL.json": 1431,
	"./news.pt-BR.json": 1432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1416;